import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import DriverDashboardWidget from "@/components/dashboard/DriverDashboardWidget";
import { Link, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function DriverDashboard() {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (!user) return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-mute">{t("dashboard.loading")}</div>;
  if (user.role === "admin") return <Navigate to="/dashboard/admin" replace />;
  if (user.role !== "driver") return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-mute">{t("admin.accessDenied")}</div>;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.25em] text-brand-red">{t("dashboard.driverSubtitle")}</div>
      <div className="flex items-center justify-between gap-3 flex-wrap mb-6">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold">{t("dashboard.driverTitle")}</h1>
        <Link to="/driver" data-testid="link-driver-active" className="inline-flex items-center gap-2 text-sm rounded-full bg-white border border-sand px-4 py-2 hover:border-brand-red hover:text-brand-red">
          {t("dashboard.activeDeliveries")} <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <DriverDashboardWidget />
    </div>
  );
}
